import { render, staticRenderFns } from "./modalLoyaltyTerms.vue?vue&type=template&id=568c64a6"
import script from "./modalLoyaltyTerms.vue?vue&type=script&lang=js"
export * from "./modalLoyaltyTerms.vue?vue&type=script&lang=js"
import style0 from "./modalLoyaltyTerms.vue?vue&type=style&index=0&id=568c64a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports